import React, { useState, useRef, useEffect } from "react";
import {
  VerifyMobileOTPServices,
  SendMobileOTPServices,
} from "../../services/index";
import { toast } from "react-toastify";
import { timerCount } from "../../config";

/* ── Step marker images ── */
import step1Img from "../../assets/image/Group 110901.png";
import step2Img from "../../assets/image/Group 110902.png";
import step3Img from "../../assets/image/Group 110919.png";
import formBgImg from "../../assets/image/Group 2147206200.png";
import about from "../../assets/image/about_nha_pg_logo.png";

const STEPS = [
  {
    img: step1Img,
    title: "Verify Aadhaar Details",
    desc: "Enter your Aadhaar number and verify with OTP received on Aadhaar linked mobile number.",
  },
  {
    img: step2Img,
    title: "Link mobile number with ABHA",
    desc: "Enter your mobile number and verify with OTP to link with ABHA Address.",
  },
  {
    img: step3Img,
    title: "Create your ABHA",
    desc: "Create your ABHA Number with a unique ABHA address.",
  },
];

const MobileVerificationOTPVerify = ({
  setMobileverifyOtp,
  setMobileVerificationOTPSent1,
  setIsconfirm,
  setCurrentStep,
}) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([]);
  const [mobileNumber, setMobileNumber] = useState("");
  const [timer, setTimer] = useState(timerCount);
  const [canResend, setCanResend] = useState(false);
  const [resendCount, setResendCount] = useState(2);
  const [disableResend, setDisableResend] = useState(false);
  const mobile = localStorage.getItem("newmobilenumber");
  const newNumber = `******${mobile.slice(6)}`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const otpValue = otp.join("");
    if (otpValue.length === 6) {
      const response = await VerifyAdharOtp(otpValue);
      // console.log(response.data,"354334");
      if (response.result.accounts) {
        localStorage.setItem("userData", JSON.stringify(response?.data));
        setCurrentStep("PerferredAbhaOptions");
      } else {
        toast.error(response?.result?.error?.message || response?.message);
      }
    } else {
      toast.error("Please enter a valid 6-digit OTP.");
    }
  };

  const handleInputChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const SendMobileOtp = async (mobilenumber) => {
    try {
      localStorage.setItem("newmobilenumber", mobilenumber);
      const body = {
        mobileNumber: mobilenumber,
        txnId: localStorage.getItem("txnId"),
      };
      const response = await SendMobileOTPServices({ body });
      if (response.status) {
        // setAdharOtp(true);
      }
    } catch (error) {
      console.error("Error while getting token:", error);
    }
  };

  const VerifyAdharOtp = async (otp) => {
    try {
      const body = {
        otpValue: otp,
        txnId: localStorage.getItem("txnId"),
      };
      const response = await VerifyMobileOTPServices({ body });
      return response;
    } catch (error) {
      console.error("Error verifying OTP:", error);
    }
  };

  useEffect(() => {
    const mobile = localStorage.getItem("newmobilenumber");
    setMobileNumber(mobile);

    let interval = null;
    if (timer > 0) {
      setCanResend(false);
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setCanResend(true);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const handleResendOtp = async () => {
    if (!canResend) return;
    if (resendCount <= 0 || disableResend) {
      setDisableResend(true);
      toast.error("You have reached the maximum resend attempts.");
      return;
    }
    try {
      const body = {
        mobileNumber: mobile,
        txnId: localStorage.getItem("txnId"),
        resent_count: resendCount,
      };
      const response = await SendMobileOTPServices({ body });
      setResendCount((prev) => {
        const newCount = prev - 1;
        if (response.resent_count === 0 || newCount <= 0) {
          setDisableResend(true);
          toast.error("You have reached the maximum resend attempts.");
        } else {
          toast.success(`OTP resent successfully`);
        }
        return newCount;
      });
      if (response.status) {
        setTimer(timerCount);
      }
    } catch (err) {
      console.error("Resend OTP failed", err);
    }
  };

  return (
    <>
      <section className="lmop-section">
        <div className="container">
          <h2 className="lmop-left-title">Create ABHA Number in 3 Steps</h2>
          <p className="lmop-left-desc">
            Create ABHA and store all your medical records in one place.
            Take part in the{" "}
            <span className="highlight">Ayushman Bharat Digital Mission (ABDM)</span>{" "}
            and get started on your digital health journey.
          </p>

          <div className="row align-items-start g-4 g-lg-5">

            {/* ── LEFT: 3 Steps ── */}
            <div className="col-12 col-md-6">
              <div className="lmop-steps">
                {STEPS.map((step, idx) => (
                  <React.Fragment key={idx}>
                    <div className="lmop-step-item">
                      <div className="lmop-step-marker">
                        <img src={step.img} alt={`Step ${idx + 1}`} />
                      </div>
                      <div className="lmop-step-body">
                        <h4>{step.title}</h4>
                        <p>{step.desc}</p>
                      </div>
                    </div>
                    {idx < STEPS.length - 1 && <div className="lmop-step-line" />}
                  </React.Fragment>
                ))}
              </div>
            </div>

            {/* ── RIGHT: OTP Verify Card ── */}
            <div className="col-12 col-md-6">
              <div
                className="lmop-card-wrap"
                style={{
                  backgroundImage: `url(${formBgImg})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div className="lmop-card-inner">
                  <h3 className="lmop-card-title">Verify Your Mobile OTP</h3>
                  <p className="lmop-card-subtitle">
                    We have sent the OTP to the mobile number ending in {newNumber}.
                  </p>
                  <form onSubmit={handleSubmit}>
                    {/* OTP Boxes */}
                    <div style={{ display: "flex", gap: "10px", justifyContent: "center", marginBottom: "18px" }}>
                      {otp?.map((digit, index) => (
                        <input
                          key={index}
                          type="text"
                          maxLength="1"
                          placeholder="0"
                          autoComplete="off"
                          value={digit}
                          ref={(el) => (inputRefs.current[index] = el)}
                          onChange={(e) => handleInputChange(e, index)}
                          onKeyDown={(e) => handleKeyDown(e, index)}
                          style={{
                            width: "44px",
                            height: "50px",
                            textAlign: "center",
                            fontSize: "1.2rem",
                            fontWeight: "700",
                            border: "1.5px solid #e2e5ec",
                            borderRadius: "10px",
                            background: "#f5f6f8",
                            outline: "none",
                            fontFamily: "Manrope, sans-serif",
                            color: "#222",
                          }}
                        />
                      ))}
                    </div>

                    <button
                      type="submit"
                      className={`lmop-continue-btn ${otp.join("").length !== 6 ? "bg-disable" : ""}`}
                      disabled={otp.join("").length !== 6}
                    >
                      Continue
                    </button>

                    <p style={{ textAlign: "center", marginTop: "14px", fontSize: "0.85rem", color: "#555" }}>
                      Didn't receive OTP?{" "}
                      {!disableResend && resendCount > 0 && !canResend ? (
                        <span style={{ color: "#1a7fff", fontWeight: "600" }}>Resend in {timer}s</span>
                      ) : (
                        <button
                          type="button"
                          onClick={handleResendOtp}
                          disabled={disableResend}
                          style={{
                            background: "none",
                            border: "none",
                            color: disableResend ? "#aaa" : "#1a7fff",
                            fontWeight: "600",
                            cursor: disableResend ? "not-allowed" : "pointer",
                            fontFamily: "Manrope, sans-serif",
                            fontSize: "0.85rem",
                            padding: 0,
                          }}
                        >
                          Resend OTP
                        </button>
                      )}
                    </p>

                    {!disableResend && resendCount > 0 && (
                      <p style={{ textAlign: "center", fontSize: "0.78rem", color: "#888" }}>
                        You have {resendCount} resend attempt{resendCount > 1 ? "s" : ""} left.
                      </p>
                    )}
                    {disableResend && (
                      <p style={{ textAlign: "center", fontSize: "0.78rem", color: "#cf1f1f" }}>
                        You have no resend attempts left.
                      </p>
                    )}
                  </form>

                  <div className="lmop-nha-row">
                    <span className="lmop-nha-label">Approved by NHA</span>
                    <img src={about} alt="NHA Logo" className="lmop-nha-logo" />
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default MobileVerificationOTPVerify;